import { useLocation } from 'react-router-dom';
import Header from './Header';
import Body from './Body';
import { useCustomDictionaryStore } from './customDictionaries/store';
import { useCustomDictionaries } from 'store/queries/dictionaries/customDictionaries';
import { useMemo } from 'react';
import styles from './Layout.module.css';

interface PageNames {
  [key: string]: {
    title: string;
    breadcrumbs: string;
  };
}

const pageNames: PageNames = {
  settings: {
    title: 'Settings',
    breadcrumbs: 'Settings',
  },
  myteam: {
    title: 'User Management',
    breadcrumbs: 'My Team',
  },
  audittrail: {
    title: 'Audit Trail',
    breadcrumbs: 'Audit Trail',
  },
  tenantmanagement: {
    title: 'Tenant Management',
    breadcrumbs: 'Tenant Management',
  },
  customdictionaries: {
    title: 'Custom Dictionaries',
    breadcrumbs: 'Custom Dictionaries',
  },
  internalapi: {
    title: 'Internal API',
    breadcrumbs: 'Internal API',
  },
  customprofiles: {
    title: 'Custom Profiles',
    breadcrumbs: 'Custom Profiles',
  },
  customstatuses: {
    title: 'Custom Statuses',
    breadcrumbs: 'Custom Statuses',
  },
};

const Layout = () => {
  const location = useLocation();
  const pathname = location.pathname.split('/');
  const { activeCustomDictionaryId } = useCustomDictionaryStore();
  const { customDictionaryList } = useCustomDictionaries();

  const activeDictionary = useMemo(() => {
    return customDictionaryList?.find((dictionary) => dictionary.id === activeCustomDictionaryId);
  }, [activeCustomDictionaryId, customDictionaryList]);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Header
          breadcrumbs={['My Account', pageNames[pathname[2]]?.breadcrumbs, activeDictionary?.name || '']}
          title={pageNames[pathname[2]]?.title}
          showAddMember={pathname[2] === 'myteam'}
          showAddTenant={pathname[2] === 'tenantmanagement'}
          showAddDictionary={pathname[2] === 'customdictionaries' && !activeCustomDictionaryId}
          showCustomStatuses={pathname[2] === 'customstatuses'}
        />
      </div>
      <div className={styles.body}>
        <Body />
      </div>
    </div>
  );
};

export default Layout;
